import { HeroSection } from "../components/home/HeroSection";
import { HighlightsSection } from "../components/home/HighlightsSection";
import { AboutSection } from "../components/home/AboutSection";
import { PrincipalSection } from "../components/home/PrincipalSection";
import { AcademicsSection } from "../components/home/AcademicsSection";
import { FacilitiesSection } from "../components/home/FacilitiesSection";
import { AchievementsSection } from "../components/home/AchievementsSection";
import { TestimonialsSection } from "../components/home/TestimonialsSection";
import { GallerySection } from "../components/home/GallerySection";
import { EventsSection } from "../components/home/EventsSection";
import { ContactSection } from "../components/home/ContactSection";

const Home = () => {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <HighlightsSection />
      <AboutSection />
      <PrincipalSection />
      <AcademicsSection />
      <FacilitiesSection />
      <AchievementsSection />
      <TestimonialsSection />
      <GallerySection />
      <EventsSection />
      <ContactSection />
    </div>
  );
};

export default Home;
